import {
    Vector2,
} from 'three';

import { EffectComposer } from 'three/examples/jsm/postprocessing/EffectComposer';
import { OutlinePass } from 'three/examples/jsm/postprocessing/OutlinePass';
import { RenderPass } from 'three/examples/jsm/postprocessing/RenderPass';
import CompositePass from '../composite/compositePass';
//import { GlitchPass } from 'three/examples/js/postprocessing/GlitchPass';

export class PostProcessing {

    constructor(scene, camera, renderer) {
        this.scene = scene;
        this.camera = camera;
        this.renderer = renderer;


        this.composer = new EffectComposer(this.renderer);

        this.renderPass = new RenderPass(this.scene, this.camera);
        this.composer.addPass(this.renderPass);

        this.outlinePass = this.setupOutlinePass();
    }

    // Put the depth composite INTO the chain rather than letting it compete
    // for the frame. It takes RenderPass's job - drawing the picture into
    // the buffer - and the outline pass then draws over the composited
    // picture, which is why hovering no longer costs the effects.
    // Passing null hands the job back to RenderPass.
    useComposite(composite) {
        if (composite && !this.compositePass) {
            this.compositePass = new CompositePass(composite, this.scene, this.camera);
            const at = this.composer.passes.indexOf(this.outlinePass);
            if (at >= 0) this.composer.insertPass(this.compositePass, at);
            else this.composer.addPass(this.compositePass);
        }
        const on = !!composite;
        if (this.compositePass) this.compositePass.enabled = on;
        // Exactly one of the two ever draws the picture.
        this.renderPass.enabled = !on;
        return this.compositePass || null;
    }


    setupOutlinePass() {
        const outlinePass = new OutlinePass(new Vector2(window.innerWidth, window.innerHeight), this.scene, this.camera);
        outlinePass.edgeStrength = 10;
        // outlinePass.edgeGlow = 0.5;
        // outlinePass.edgeThickness = 2;
        outlinePass.pulsePeriod = 3;
        outlinePass.visibleEdgeColor.set('#0066ff');
        outlinePass.hiddenEdgeColor.set('#190a05');
        this.composer.addPass(outlinePass);

        return outlinePass
    }
}